// @flow

import { WelcomeMessage } from '../../../models'

import type { RootState } from '../../rootState'

import { createGrowthImpression } from '../../../../common/api/chatchampApi'

export const actions = {
  async resetOpenChat ({ dispatch }: { dispatch: any }) {
    await dispatch('setMessageHistory', [])
  },
  async openChatClicked ({
    commit,
    dispatch
  }: { commit: any, dispatch: any }) {
    if (await dispatch('redirectWelcomeMessageToWizard')) return

    await commit('setHasChatBubbleBeenOpened', true)
    await dispatch('resetOpenChat')
    await dispatch('welcomeMessageClick')
    await dispatch('welcomeMessageClosed')
  },
  async showOpenChat ({
    dispatch,
    rootState
  }: { dispatch: any, rootState: RootState }, openChat: WelcomeMessage) {
    await dispatch('open')
    await dispatch('setOpenChat', openChat)
    await dispatch('trackOpenChat', openChat)
  },
  async replaceOpenChat ({ dispatch }: { dispatch: any }, openChat: WelcomeMessage) {
    await dispatch('setOpenChat', openChat)
    await dispatch('trackOpenChat', openChat)
  },
  async setOpenChat ({ dispatch }: { dispatch: any }, openChat: WelcomeMessage) {
    await dispatch('setMessageHistory', [{
      id: 1,
      type: 'message',
      from: '1234',
      to: 'visitor-id',
      content: {
        text: openChat.description,
        quick_replies: openChat.openChatButtons()
      },
      payload: openChat.payload
    }])
    await dispatch('welcomeMessageShownById', openChat.id)
  },
  async trackOpenChat ({ rootState }: { rootState: RootState }, openChat: WelcomeMessage) {
    await createGrowthImpression(rootState.customerId, rootState.subscriberId, openChat.id, rootState.parentUrl, rootState.device)
  }
}
